export default __webpack_public_path__ + "static/media/horse-oracle-rotated.48547b6e.svg";